import './App.scss';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './pages/Home';
import Books from './pages/Books';
import EBooks from './pages/EBooks';

import LogIn from './pages/LogIn';
import Register from './pages/Register';
import ForgotPasswort from './pages/ForgotPassword';
import PageNotFound from './pages/PageNotFound';

import PrivateRoute from './components/PrivateRoute';
import MyLibrary from './pages/MyLibrary';
import AddBook from './pages/AddBook';
import BookLibrary from './pages/BookLibrary';

import Navbar from './layout/Navbar';
import Footer from './layout/Footer';

function App() {
  return (
    <Router>
      <div className="main-container">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/books" element={<Books />} />
          <Route path="/e-books" element={<EBooks />} />

          <Route path="/login" element={<LogIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPasswort />} />
          <Route path="/*" element={<PageNotFound />} />

          <Route path="/my-library" element={<PrivateRoute />}>
            <Route path="/my-library" element={<MyLibrary />} />
            <Route path="/my-library/add-book" element={<AddBook />} />
            <Route path="/my-library/my-books" element={<BookLibrary />} />
          </Route>
        </Routes>

        <Footer />
        <ToastContainer />
      </div>
    </Router>
  );
}

export default App;
